import AgreementPdfViewer from './AgreementPdfViewer.component';

export type { AgreementPageLayerProps } from './AgreementPdfViewer.component';

export default AgreementPdfViewer;
